import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTwitterAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.24988 2.24963C-0.00012207 4.49884 -0.00012207 8.11914 -0.00012207 15.3602V16.6398C-0.00012207 23.8809 -0.00012207 27.5012 2.24988 29.7504C4.49841 32 8.11853 32 15.3593 32H16.6405C23.8812 32 27.5013 32 29.7499 29.7504C31.9999 27.5012 31.9999 23.8809 31.9999 16.6398V15.3602C31.9999 8.11914 31.9999 4.49884 29.7499 2.24963C27.5013 0 23.8812 0 16.6405 0H15.3593C8.11853 0 4.49841 0 2.24988 2.24963ZM18.3296 14.4805L25.6996 6.05701H22.3262L16.7673 12.4113L11.961 6.05701H4.99988L13.3173 16.9331L5.43431 25.9429H8.80982L14.8939 18.991L20.2111 25.9429H26.9999L18.3296 14.4805ZM10.9453 7.97013L23.0115 23.9237H21.1422L8.93934 7.97013H10.9453Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTwitterAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
